module.exports = __webpack_public_path__ + "static/the-enemy-97d1de66bc1dfbc7a9cf7dd185499aa4.jpg";